import React from "react";
import productImg from "../../Assets/8th_slider/pngegg (3) 1.png";

const products = Array.from({ length: 6 }, () => ({
  title: "Shelcal Total Supplement With...",
  mrp: "₹ 820.00",
  price: "₹ 697.00",
  discount: "15%",
  img: productImg,
}));

const Product_slider = () => {
  return (
    <section className="w-full bg-white py-12">
      <div className="max-w-7xl mx-auto px-4">

        <div className="flex items-start justify-between mb-8">
          <div>
            <h2 className="text-[30px] font-medium text-black">
              Trending Near You
            </h2>
            <p className="text-[18px] text-[#AAAAAA]">
              Popular in your city
            </p>
          </div>

          <button className="text-[20px] font-medium text-[#187685]">
            View All
          </button>
        </div>

        {/* Mobile */}
        <div className="flex gap-5 overflow-x-auto md:hidden pb-3">
          {products.map((item, index) => (
            <div key={index} className="w-[175px] flex-shrink-0">
              <div className="w-[175px] h-[175px] bg-[#FAFAFA] rounded-[12.59px] flex items-center justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-[125px] h-[125px] object-contain"
                />
              </div>

              <p className="mt-3 text-[15px] text-[#060A0B]">
                {item.title}
              </p>
              <p className="text-[12px] text-[#A4A5A8] line-through">
                MRP {item.mrp}
              </p>
              <p className="text-[14px] text-[#060A0B]">
                {item.price}{" "}
                <span className="text-red-600">({item.discount})</span>
              </p>
            </div>
          ))}
        </div>

        {/* Desktop */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-6 gap-6">
          {products.map((item, index) => (
            <div key={index} className="w-[175px]">
              <div className="w-[175px] h-[175px] bg-[#FAFAFA] rounded-[12.59px] flex items-center justify-center">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-[125px] h-[125px] object-contain"
                />
              </div>

              <p className="mt-3 text-[15px] text-[#060A0B]">
                {item.title}
              </p>
              <p className="text-[12px] text-[#A4A5A8] line-through">
                MRP {item.mrp}
              </p>
              <p className="text-[14px] text-[#060A0B]">
                {item.price}{" "}
                <span className="text-red-600">({item.discount})</span>
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Product_slider;
